import { CircleRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathCirclePicker, MathPickerContribution } from "../constants";

import { DefaultMathCirclePicker } from "./circle-picker";

let loadCirclePick = !1;

export function bindCircleMathPickerContribution(container) {
    loadCirclePick || (loadCirclePick = !0, container.bind(MathCirclePicker).toDynamicValue((() => new DefaultMathCirclePicker(resolveContainerBinding(container, CircleRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathCirclePicker));
}
//# sourceMappingURL=circle-module.js.map
